import { client } from 'app/http';

export const getRepoZip = async (jobId: string, workspaceId: string) => {
  const { data } = await client.get(`/${workspaceId}/jobs/${jobId}/repo/zip`);
  return data;
};
